import React, { useContext, useState } from 'react';
import styled from 'styled-components';

import AnswerList from 'components/customer/answer_panel/search/answer_list';
import AnswerPanelContext from 'components/customer/answer_panel/answer_panel_context';
import LoadMoreAnswerSearchResults from 'actions/answers/load_more_answer_search_results';
import ScrollNotifier from 'components/lib/scroll_notifier';
import Spinner from 'components/common/spinner';
import useExecuteAction from 'components/hooks/use_execute_action';

// Trigger the next page when the scroll position is within ~2 list-row heights of the bottom.
const SCROLL_THRESHOLD = 64;

export default function AnswerSearchResults() {
  const { answersList, focusedAnswer, isLoadingMoreSearchResults, searchText } = useContext(AnswerPanelContext);
  const executeAction = useExecuteAction();
  const [scrollContainer, setScrollContainer] = useState(null);

  const handleScroll = () => {
    if (!scrollContainer) return;
    const { scrollTop, clientHeight, scrollHeight } = scrollContainer;
    if (scrollTop + clientHeight >= scrollHeight - SCROLL_THRESHOLD) {
      executeAction(LoadMoreAnswerSearchResults);
    }
  };

  return (
    <Results data-aid="answerPanel-searchResults" ref={setScrollContainer}>
      <ScrollNotifier onScroll={handleScroll} scrollingParent={scrollContainer}>
        <React.Fragment>
          <AnswerList
            answers={answersList.answers}
            searchText={searchText}
            selectedAnswerId={focusedAnswer && focusedAnswer.id}
          />
          {isLoadingMoreSearchResults && (
            <LoadingMoreRow data-aid="answerPanel-loadingMore">
              <Spinner size={24} />
            </LoadingMoreRow>
          )}
        </React.Fragment>
      </ScrollNotifier>
    </Results>
  );
}

const Results = styled.div`
  flex: 1 1 auto;
  overflow: auto;
`;

const LoadingMoreRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 12px 0;
`;
